import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

import { IonButton, IonSpinner } from '@ionic/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
  primary: {
    type: Boolean,
    default: true,
  },
  secondary: {
    type: Boolean,
    default: false,
  },
  blank: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  white: {
    type: Boolean,
    default: false,
  },
  rounded: {
    type: Boolean,
    default: false,
  },
},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonButton), _mergeProps({
    class: [
      'base-button',
      { 'base-button--primary': props.primary },
      { 'base-button--secondary': props.secondary },
      { 'base-button--blank': props.blank },
      { 'base-button--white': props.white },
      { 'base-button--round': props.rounded },
    ]
  }, _ctx.$attrs, {
    disabled: props.disabled || props.loading,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click', $event)))
  }), {
    default: _withCtx(() => [
      (!props.loading)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 })
        : (_openBlock(), _createBlock(_unref(IonSpinner), {
            key: 1,
            name: "lines-sharp-small"
          }))
    ]),
    _: 3
  }, 16, ["class", "disabled"]))
}
}

})